<i18n src='../../static/localization/analytics.json'></i18n>
<template>
  <div class="scroll-y" id="analytics">
    <!-- <span class='icon closeicon is-small' v-on:click='showAnalytics=!showAnalytics'>
      <i class='fa fa-times-circle' aria-hidden='true'></i>
    </span>-->
    <div v-show="loader" class="spinner">
      <i class="fa fa-circle-o-notch fa-spin fa-3x" style="font-size:40px;color:#228D7A;"></i>
    </div>
    <div v-show="loader" class="spinnerBackground"></div>

    <div class="controlPanel">
      <div class="selectSensor">
        <v-form ref="form" lazy-validation class="sensorForm">
          <v-select
            label="Vyberte senzor"
            :value="selectedSensor"
            @change="selectSensor"
            :items="sensors"
          ></v-select>
        </v-form>
      </div>
      <div class="selectDate">
        <p class="caption annot">{{ $t('controlPanel.selectDate') }}</p>
        <input class="datepicker" type="text" name="daterange">
      </div>
    </div>
    <div class="wrapper">
      <v-layout row class="blue lighten-2 stats">
        <v-flex xs12>
          <h3 class="headline">
            {{ $t('statsDashboard.currentValues') }}
            <span
              class="subheading"
            >({{ $t('statsDashboard.lastUpdate') }} {{dailyValues.time}})</span>
          </h3>
          <v-card class="elevation-1 card">
            <v-card-title primary-title>
              <div>
                <div class="subheading">
                  <v-icon class="currentValueIcon" color="red">fa-thermometer-full</v-icon>
                  {{ $t('statsDashboard.temperature') }}
                </div>
                <h4 class="headline">{{ dailyValues.temp }} &deg;C</h4>
              </div>
            </v-card-title>
          </v-card>

          <!-- <v-card class="elevation-1 card">
            <v-card-title primary-title>
              <div>
                <div class="subheading"><v-icon class="currentValueIcon" color="blue">fa-thermometer-full</v-icon>{{ $t('statsDashboard.temperature_ext') }}</div>
                <h4 class="headline">{{ dailyValues.temp_ext }} &deg;C</h4>
              </div>
            </v-card-title>
          </v-card>-->
          <v-card class="elevation-1 card">
            <v-card-title primary-title>
              <div>
                <div class="subheading">
                  <v-icon class="currentValueIcon" color="blue darken-3">fa-tint</v-icon>
                  {{ $t('statsDashboard.moisture') }}
                </div>
                <h4 class="headline">{{ dailyValues.moist }} %</h4>
              </div>
            </v-card-title>
          </v-card>

          <v-card class="elevation-1 card">
            <v-card-title primary-title>
              <div>
                <div class="subheading">
                  <v-icon class="currentValueIcon" color="orange darken-3">fa-dashboard</v-icon>
                  {{ $t('statsDashboard.pressure') }}
                </div>
                <h4 class="headline">{{ dailyValues.press }} hPa</h4>
              </div>
            </v-card-title>
          </v-card>

          <v-card class="elevation-1 card">
            <v-card-title primary-title>
              <div>
                <div class="subheading">
                  <v-icon class="currentValueIcon" color="indigo">fa-cloud</v-icon>
                  {{ $t('statsDashboard.precipitation') }}
                </div>
                <h4 class="headline">{{ dailyValues.prec }} mm/m2/h</h4>
              </div>
            </v-card-title>
          </v-card>
        </v-flex>
      </v-layout>

      <v-layout row class="grey lighten-4 stats">
        <v-flex xs12>
          <h3 class="headline">{{ $t('statsDashboard.dailyStatistics') }}</h3>

          <v-card class="elevation-1 card">
            <v-card-title primary-title>
              <div>
                <div class="subheading">
                  <v-icon color="red">fa-thermometer-full</v-icon>
                </div>
                <span class="grey--text">{{ $t('statsDashboard.maxT') }}</span>
                <h4 class="headline">{{ dailyStats.maxTemp }} &deg;C</h4>
              </div>
            </v-card-title>
          </v-card>

          <v-card class="elevation-1 card">
            <v-card-title primary-title>
              <div>
                <div class="subheading">
                  <v-icon color="indigo">fa-thermometer-empty</v-icon>
                </div>
                <span class="grey--text">{{ $t('statsDashboard.minT') }}</span>
                <h4 class="headline">{{ dailyStats.minTemp }} &deg;C</h4>
              </div>
            </v-card-title>
          </v-card>
        </v-flex>
      </v-layout>

      <div id="windchart"></div>
    </div>

    <div class="chartArea">
      <div id="chartdiv" style="width: 100%; height: 400px;"></div>
    </div>
  </div>
</template>

<script>
import 'amcharts3'
import 'amcharts3/amcharts/serial'
const Highcharts = require('highcharts')
import moment from 'moment'
import $ from 'jquery'
import daterangepicker from 'bulma-daterangepicker'
import { mapMutations } from 'vuex'

import { HTTP } from '../common/http'
import { componentStrings } from '../../static/localization/componentStrings'

require('highcharts/modules/exporting')(Highcharts)
require('highcharts/modules/export-data')(Highcharts)
require('highcharts/highcharts-more')(Highcharts)

export default {
  name: 'analytics',
  mounted () {
    this.$i18n.locale = 'sk'
    this.mountDatePicker() // this funtion mounts datepicker
    this.datePickerListener(this) // this function is listening the datepicker events
    this.getSensorList() // gets sensor list to dropdown
    // this.selectSensor(this.selectedSensor[0])
  },
  data () {
    return {
      showAnalytics: true,
      sensors: [],
      todayData: [],
      selectedSensor: null,
      selectedDate: null,
      dailyValues: {},
      dailyStats: {},
      loader: false,
      statsShow: false,
      date: null,
      menu: false
    }
  },
  methods: {
    ...mapMutations(['loadSensors']),
    selectSensor: function (sensor) {
      const inputVal = $('.datepicker').val()
      // console.log(moment(moment(inputVal.split(' - ')[0], 'DD-MM-YYYY')).startOf('day').add(1,'hour').valueOf())
      // console.log(moment(moment(inputVal.split(' - ')[1], 'DD-MM-YYYY')).endOf('day').valueOf())
      this.dataToChart(
        this.$store.getters.getSensors.filter(s => s.label === sensor[0])[0].value,
        moment(moment(inputVal.split(' - ')[0], 'DD-MM-YYYY')).startOf('day').add(1,'hour').valueOf(),
        moment(moment(inputVal.split(' - ')[1], 'DD-MM-YYYY')).endOf('day').valueOf(),
        // moment(moment(inputVal.split(' - ')[0], 'DD-MM-YYYY')).valueOf(),
        // moment(moment(inputVal.split(' - ')[1], 'DD-MM-YYYY')).valueOf(),
      )
    },
    getDailyStats: function (sensorId) {
      HTTP.get('/sensors/' + sensorId + '/dailyStats')
        .then(response => {
          this.dailyValues = response.data.currentValues
          this.dailyStats = response.data.dailyStats
        })
        .catch(error => {
          console.log('ERROR: ' + error)
        })
    },
    dataToChart: function (sensorId, from, to) {
      this.loader = true
      const apiCallPath = sensorId === 'FTP' ? '/ftp' : `/sensors/${sensorId}`
      HTTP.get('/ftp', {
        params: {
          from: from,
          to: to
        }
      })
        .then(response => {
          this.loader = false
          // this.windchartInit(response.data)
          this.windStatsComputer(response.data)
        })
        .catch(error => {
          console.log('ERROR: ' + error)
        })
      HTTP.get(apiCallPath, {
        params: {
          from: from,
          to: to
        }
      })
        .then(response => {
          this.loader = false
          this.getDailyStats(sensorId)
          this.drawChart(response.data)
        })
        .catch(error => {
          console.log('ERROR: ' + error)
        })
    },
    windStatsComputer: function (data) {
      const windSpeedGroup = {}
      windSpeedGroup.i = data.data.filter(a => a.windSpeedAvg < 0.5)
      windSpeedGroup.ii = data.data.filter(a => a.windSpeedAvg >= 0.5 && a.windSpeedAvg < 2)
      windSpeedGroup.iii = data.data.filter(a => a.windSpeedAvg >= 2 && a.windSpeedAvg < 4)
      windSpeedGroup.iiii = data.data.filter(a => a.windSpeedAvg >= 4 && a.windSpeedAvg < 6)
      windSpeedGroup.iiiii = data.data.filter(a => a.windSpeedAvg >= 6 && a.windSpeedAvg < 8)
      windSpeedGroup.iiiiii = data.data.filter(a => a.windSpeedAvg >= 8 && a.windSpeedAvg < 10)
      windSpeedGroup.iiiiiii = data.data.filter(a => a.windSpeedAvg > 10)

      const windDataSeries = []

      for (const key in windSpeedGroup) {
        const value = windSpeedGroup[key]
        const windDirectionsGroup = {}
        const windDirectionsAvgGroup = {}

        windDirectionsGroup.N = value.filter(a => a.windDir >= 0 && a.windDir <= 22.5).map(b => Number(b.windSpeedAvg))
        windDirectionsGroup.NNE = value.filter(a => a.windDir > 22.5 && a.windDir <= 45).map(b => Number(b.windSpeedAvg))
        windDirectionsGroup.NE = value.filter(a => a.windDir > 45 && a.windDir <= 67.5).map(b => Number(b.windSpeedAvg))
        windDirectionsGroup.ENE = value.filter(a => a.windDir > 67.5 && a.windDir <= 90).map(b => Number(b.windSpeedAvg))
        windDirectionsGroup.E = value.filter(a => a.windDir > 90 && a.windDir <= 112.5).map(b => Number(b.windSpeedAvg))
        windDirectionsGroup.ESE = value.filter(a => a.windDir > 112.5 && a.windDir <= 135).map(b => Number(b.windSpeedAvg))
        windDirectionsGroup.SE = value.filter(a => a.windDir > 135 && a.windDir <= 157.5).map(b => Number(b.windSpeedAvg))
        windDirectionsGroup.SSE = value.filter(a => a.windDir > 157.5 && a.windDir <= 180).map(b => Number(b.windSpeedAvg))
        windDirectionsGroup.S = value.filter(a => a.windDir > 180 && a.windDir <= 202.5).map(b => Number(b.windSpeedAvg))
        windDirectionsGroup.SEW = value.filter(a => a.windDir > 202.5 && a.windDir <= 225).map(b => Number(b.windSpeedAvg))
        windDirectionsGroup.SW = value.filter(a => a.windDir > 225 && a.windDir <= 247.5).map(b => Number(b.windSpeedAvg))
        windDirectionsGroup.WSW = value.filter(a => a.windDir > 247.5 && a.windDir <= 270).map(b => Number(b.windSpeedAvg))
        windDirectionsGroup.W = value.filter(a => a.windDir > 270 && a.windDir <= 292.5).map(b => Number(b.windSpeedAvg))
        windDirectionsGroup.WNW = value.filter(a => a.windDir > 292.5 && a.windDir <= 315).map(b => Number(b.windSpeedAvg))
        windDirectionsGroup.NW = value.filter(a => a.windDir > 315 && a.windDir <= 337.5).map(b => Number(b.windSpeedAvg))
        windDirectionsGroup.NNW = value.filter(a => a.windDir > 337.5 && a.windDir <= 360).map(b => Number(b.windSpeedAvg))

        windDirectionsAvgGroup.N = ['N', windDirectionsGroup.N.length > 0 ? windDirectionsGroup.N.reduce((accumulator, currentValue) => accumulator + currentValue) / windDirectionsGroup.N.length : 0]
        windDirectionsAvgGroup.NNE = ['NNE', windDirectionsGroup.NNE.length > 0 ? windDirectionsGroup.NNE.reduce((accumulator, currentValue) => accumulator + currentValue) / windDirectionsGroup.NNE.length : 0]
        windDirectionsAvgGroup.NE = ['NE', windDirectionsGroup.NE.length > 0 ? windDirectionsGroup.NE.reduce((accumulator, currentValue) => accumulator + currentValue) / windDirectionsGroup.NE.length : 0]
        windDirectionsAvgGroup.ENE = ['ENE', windDirectionsGroup.ENE.length > 0 ? windDirectionsGroup.ENE.reduce((accumulator, currentValue) => accumulator + currentValue) / windDirectionsGroup.ENE.length : 0]
        windDirectionsAvgGroup.E = ['E', windDirectionsGroup.E.length > 0 ? windDirectionsGroup.E.reduce((accumulator, currentValue) => accumulator + currentValue) / windDirectionsGroup.E.length : 0]
        windDirectionsAvgGroup.ESE = ['ESE', windDirectionsGroup.ESE.length > 0 ? windDirectionsGroup.ESE.reduce((accumulator, currentValue) => accumulator + currentValue) / windDirectionsGroup.ESE.length : 0]
        windDirectionsAvgGroup.SE = ['SE', windDirectionsGroup.SE.length > 0 ? windDirectionsGroup.SE.reduce((accumulator, currentValue) => accumulator + currentValue) / windDirectionsGroup.SE.length : 0]
        windDirectionsAvgGroup.SSE = ['SSE', windDirectionsGroup.SSE.length > 0 ? windDirectionsGroup.SSE.reduce((accumulator, currentValue) => accumulator + currentValue) / windDirectionsGroup.SSE.length : 0]
        windDirectionsAvgGroup.S = ['S', windDirectionsGroup.S.length > 0 ? windDirectionsGroup.S.reduce((accumulator, currentValue) => accumulator + currentValue) / windDirectionsGroup.S.length : 0]
        windDirectionsAvgGroup.SEW = ['SEW', windDirectionsGroup.SEW.length > 0 ? windDirectionsGroup.SEW.reduce((accumulator, currentValue) => accumulator + currentValue) / windDirectionsGroup.SEW.length : 0]
        windDirectionsAvgGroup.SW = ['SW', windDirectionsGroup.SW.length > 0 ? windDirectionsGroup.SW.reduce((accumulator, currentValue) => accumulator + currentValue) / windDirectionsGroup.SW.length : 0]
        windDirectionsAvgGroup.WSW = ['WSW', windDirectionsGroup.WSW.length > 0 ? windDirectionsGroup.WSW.reduce((accumulator, currentValue) => accumulator + currentValue) / windDirectionsGroup.WSW.length : 0]
        windDirectionsAvgGroup.W = ['W', windDirectionsGroup.W.length > 0 ? windDirectionsGroup.W.reduce((accumulator, currentValue) => accumulator + currentValue) / windDirectionsGroup.W.length : 0]
        windDirectionsAvgGroup.WNW = ['WNW', windDirectionsGroup.WNW.length > 0 ? windDirectionsGroup.WNW.reduce((accumulator, currentValue) => accumulator + currentValue) / windDirectionsGroup.WNW.length : 0]
        windDirectionsAvgGroup.NW = ['NW', windDirectionsGroup.NW.length > 0 ? windDirectionsGroup.NW.reduce((accumulator, currentValue) => accumulator + currentValue) / windDirectionsGroup.NW.length : 0]
        windDirectionsAvgGroup.NNW = ['NNW', windDirectionsGroup.NNW.length > 0 ? windDirectionsGroup.NNW.reduce((accumulator, currentValue) => accumulator + currentValue) / windDirectionsGroup.NNW.length : 0]

        let interval = ''

        switch (key) {
          case 'i':
            interval = '< 0.5 m/s'
            break
          case 'ii':
            interval = '0.5-2 m/s'
            break
          case 'iii':
            interval = '2-4 m/s'
            break
          case 'iiii':
            interval = '4-6 m/s'
            break
          case 'iiiii':
            interval = '6-8 m/s'
            break
          case 'iiiiii':
            interval = '8-10 m/s'
            break
          case 'iiiiiii':
            interval = '> 10 m/s'
            break
        }

        windDataSeries.push({
          'type': 'column',
          'name': interval,
          'data': Object.values(windDirectionsAvgGroup)
        })
      }

      this.windchartInit(windDataSeries)
    },
    windchartInit: function (data) {
      Highcharts.chart('windchart', {
        chart: {
          polar: true,
          type: 'column',
          spacing: [0, 0, 0, 0]
        },

        title: {
          text: 'Smer a intenzita vetru'
        },
        pane: {
          size: '100%'
        },
        exporting: { enabled: false },

        legend: {
          align: 'center',
          verticalAlign: 'bottom',
          // y: 100,
          layout: 'vertical'
        },

        xAxis: {
          tickmarkPlacement: 'on',
          type: 'category'
        },

        yAxis: {
          min: 0,
          endOnTick: false,
          showLastLabel: true,
          reversedStacks: false
        },

        tooltip: {
          valueSuffix: '%',
          valueDecimals: 1
        },

        plotOptions: {
          series: {
            stacking: 'normal',
            shadow: false,
            groupPadding: 0,
            pointPlacement: 'on'
          }
        },

        series: data
      })
    },
    getSensorList: function () {
      HTTP.get('/sensors/byUser/' + '09805308-25ab-4b49-bb7d-8eecd2c077a1')
        .then(response => {
          this.sensors = response.data.data.map(sensor => [sensor.label])
          // return { label: sensor.label, value: sensor.sensorId }
          this.$store.commit(
            'loadSensors',
            response.data.data.map(function (sensor) {
              return { label: sensor.label, value: sensor.sensorId }
            }),
          )
          this.selectedSensor = this.sensors[0]
          this.selectSensor(this.sensors[0])
        })
        .catch(error => {
          console.log('ERROR: ' + error)
        })
    },
    mountDatePicker: function () {
      $('input[name="daterange"]').daterangepicker({
        // minDate: '25/10/2017',
        startDate: moment(),
        alwaysShowCalendars: true,
        locale: {
          format: 'DD/MM/YYYY'
        },
        ranges: {
          Dnes: [moment(), moment()],
          Vcera: [moment().subtract(1, 'days'), moment().subtract(1, 'days')],
          'Last 7 Days': [moment().subtract(6, 'days'), moment()],
          'Last 30 Days': [moment().subtract(29, 'days'), moment()],
          'This Month': [moment().startOf('month'), moment().endOf('month')],
          'Last Month': [
            moment()
              .subtract(1, 'month')
              .startOf('month'),
            moment()
              .subtract(1, 'month')
              .endOf('month')
          ]
        }
      })
      $('.ranges ul li')
        .eq(0)
        .text(componentStrings.datepicker[this.$i18n.locale].today)
      $('.ranges ul li')
        .eq(1)
        .text(componentStrings.datepicker[this.$i18n.locale].yesterday)
      $('.ranges ul li')
        .eq(2)
        .text(componentStrings.datepicker[this.$i18n.locale].last7days)
      $('.ranges ul li')
        .eq(3)
        .text(componentStrings.datepicker[this.$i18n.locale].last30days)
      $('.ranges ul li')
        .eq(4)
        .text(componentStrings.datepicker[this.$i18n.locale].thisMonth)
      $('.ranges ul li')
        .eq(5)
        .text(componentStrings.datepicker[this.$i18n.locale].lastMonth)
      $('.ranges ul li')
        .eq(6)
        .text(componentStrings.datepicker[this.$i18n.locale].customRange)
      $('.applyBtn').text(componentStrings.datepicker[this.$i18n.locale].apply)
      $('.cancelBtn').text(componentStrings.datepicker[this.$i18n.locale].cancel)
    },
    datePickerListener: function (VueInstance) {
      $('.datepicker').on('apply.daterangepicker', function (ev, picker) {
        VueInstance.dataToChart(
          VueInstance.$store.getters.getSensors.filter(sensor => sensor.label === VueInstance.selectedSensor[0])[0]
            .value,
          moment.utc(picker.startDate.format('YYYY-MM-DD')).valueOf(),
          moment.utc(picker.endDate.format('YYYY-MM-DD')).valueOf(),
        )
      })
    },
    drawChart: function (data) {
      const chart = window.AmCharts.makeChart('chartdiv', {
        type: 'serial',
        theme: 'light',
        pathToImages: '../../static/img/amcharts/images/',
        legend: {
          useGraphSettings: true
        },
        dataProvider: data.data,
        synchronizeGrid: true,
        zoomOutText: componentStrings.datepicker[this.$i18n.locale].showAll,
        valueAxes: [
          {
            id: 'temp',
            axisColor: '#d64444',
            axisAlpha: 1,
            gridAlpha: 0.2,
            axisThickness: 2,
            dashLength: 1,
            position: 'left'
          },
          {
            id: 'snowTemp',
            axisColor: '#fc6b03',
            axisAlpha: 1,
            gridAlpha: 0.2,
            axisThickness: 2,
            dashLength: 1,
            position: 'left'
          },
          {
            id: 'moist',
            axisColor: '#89d9f4',
            axisAlpha: 1,
            gridAlpha: 0,
            offset: 50,
            axisThickness: 2,
            dashLength: 1,
            position: 'left',
            min: 0,
            max: 100,
            strictMinMax: true,
            unit: '%'
          },
          {
            id: 'press',
            axisColor: '#ffa100',
            axisAlpha: 1,
            gridAlpha: 0,
            offset: 50,
            axisThickness: 2,
            dashLength: 1,
            minimum: 0,
            position: 'right'
          },
          {
            id: 'prec',
            axisColor: '#003fff',
            axisAlpha: 1,
            gridAlpha: 0,
            minimum: 0,
            axisThickness: 2,
            dashLength: 1,
            position: 'right'
          },
          {
            id: 'irr',
            axisColor: '#c49f09',
            axisAlpha: 1,
            gridAlpha: 0,
            minimum: 0,
            axisThickness: 2,
            dashLength: 1,
            position: 'left'
          },
          {
            id: 'windSpeedMax',
            axisColor: '#254984',
            axisAlpha: 1,
            gridAlpha: 0,
            offset: 0,
            axisThickness: 2,
            dashLength: 1,
            minimum: 0,
            position: 'right'
          },
          {
            id: 'windSpeedAvg',
            axisColor: '#7ba8f2',
            axisAlpha: 1,
            gridAlpha: 0,
            offset: 50,
            axisThickness: 2,
            dashLength: 1,
            minimum: 0,
            position: 'right'
          }
        ],
        mouseWheelZoomEnabled: true,
        graphs: [
          {
            valueAxis: 'temp',
            id: 'temp',
            // type: 'smoothedLine',
            balloonText: '[[value]] &degC',
            lineColor: '#d64444',
            title: componentStrings.sensorChart[this.$i18n.locale].temperature,
            valueField: 'temp',
            fillAlphas: 0,
            useLineColorForBulletBorder: true
          },
          {
            valueAxis: 'snowTemp',
            id: 'snowTemp',
            // type: 'smoothedLine',
            balloonText: '[[value]] &degC',
            lineColor: '#fc6b03',
            title: componentStrings.sensorChart[this.$i18n.locale].snowTemperature,
            valueField: 'snowTemp',
            fillAlphas: 0,
            useLineColorForBulletBorder: true
          },
          {
            valueAxis: 'moist',
            id: 'moist',
            // type: 'smoothedLine',
            balloonText: '[[value]] %',
            lineColor: '#89d9f4',
            title: componentStrings.sensorChart[this.$i18n.locale].moisture,
            valueField: 'moist',
            fillAlphas: 0,
            useLineColorForBulletBorder: true
          },
          {
            valueAxis: 'press',
            id: 'press',
            // type: 'smoothedLine',
            balloonText: '[[value]] hPa',
            lineColor: '#ffa100',
            title: componentStrings.sensorChart[this.$i18n.locale].pressure,
            valueField: 'press',
            fillAlphas: 0,
            useLineColorForBulletBorder: true
          },
          {
            valueAxis: 'prec',
            id: 'prec',
            type: 'column',
            balloonText: '[[value]] mm/m2',
            lineColor: '#003fff',
            title: componentStrings.sensorChart[this.$i18n.locale].precipitation,
            valueField: 'prec',
            fillAlphas: 0,
            useLineColorForBulletBorder: true
          },
          {
            valueAxis: 'irr',
            id: 'irr',
            // type: 'smoothedLine',
            balloonText: '[[value]] W/m2',
            lineColor: '#c49f09',
            title: componentStrings.sensorChart[this.$i18n.locale].irradiation,
            valueField: 'irr',
            fillAlphas: 0,
            useLineColorForBulletBorder: true
          },
          {
            valueAxis: 'windSpeedMax',
            id: 'windSpeedMax',
            balloonText: '[[value]] m/s',
            lineColor: '#254984',
            title: componentStrings.sensorChart[this.$i18n.locale].windSpeedMax,
            valueField: 'windSpeedMax',
            fillAlphas: 0,
            useLineColorForBulletBorder: true
          },
          {
            valueAxis: 'windSpeedAvg',
            id: 'windSpeedAvg',
            balloonText: '[[value]] m/s',
            lineColor: '#7ba8f2',
            title: componentStrings.sensorChart[this.$i18n.locale].windSpeedAvg,
            valueField: 'windSpeedAvg',
            fillAlphas: 0,
            useLineColorForBulletBorder: true
          }
        ],
        chartScrollbar: {
          autoGridCount: true,
          graph: 'temp',
          scrollbarHeight: 60,
          dragIcon: 'dragIconRectSmall',
          dragIconWidth: 20,
          dragIconHeight: 25
        },
        chartCursor: {
          // 'limitToGraph':'temp',
          // 'cursorPosition': 'mouse'
        },
        dataDateFormat: 'DD/MM/YYYY JJ:NN',
        categoryField: 'time',
        categoryAxis: {
          parseDates: true,
          axisColor: '#DADADA',
          dashLength: 1,
          minorGridEnabled: true,
          labelFrequency: 2,
          minPeriod: 'mm',
          columnWidth: 0.5
        }
      })

      chart.addListener('rendered', zoomChart)

      zoomChart()

      // this method is called when chart is first inited as we listen for 'rendered' event
      function zoomChart () {
        // different zoom methods can be used - zoomToIndexes, zoomToDates, zoomToCategoryValues
        chart.zoomToIndexes(data.data.length - 40, data.data.length - 1)
      }
    }
  }
}
</script>

<style scoped>
@import '../../static/style/daterangepicker.css';

#analytics {
	position: relative;
	height: -webkit-fill-available;
	width: 100%;
	z-index: 1001;
	background: #ffffff;
	display: none;
}

.chartArea {
	position: relative;
	/* bottom: 30px; */
	width: 100%;
	margin: 0 auto;
}
@media (max-width: 1555px) {
	.chartArea {
		position: relative;
	}
}
.panel {
	display: block;
	position: absolute;
	width: 225px;
}
.panel-heading {
	border-radius: 0;
}
a.panel-block:hover,
label.panel-block:hover {
	background-color: rgba(123, 193, 106, 0.17);
}
.dropdown {
	display: block;
	width: 225px;
	margin-bottom: 25px;
	margin: 0 auto;
	position: relative;
}
.sensorForm {
	width: 240px;
}
.selectDate .datepicker {
	width: 240px;
	height: 28px;
	float: right;
	font-size: 16px;
	font-weight: 500;
	outline: none;
}
.selectSensor {
	margin-right: 20px;
}
.selectDate {
	margin-left: 20px;
	padding-top: 2px;
}
.selectDate p {
	margin-bottom: 0px;
}
.controlPanel {
	position: relative;
	margin: 0 auto;
	display: flex;
	width: 600px;
	margin-top: 8px;
	margin-bottom: 38px;
}
.dashboard {
	margin-left: 25px;
	margin-right: 25px;
}
.column {
	padding: 0;
}
.daterangepicker.dropdown-menu {
	z-index: 9999 !important;
}
.annot {
	font-size: 16px;
}
.stats {
	padding: 15px;
	width: 50%;
	display: inline-block;
}
.statsDashboard {
	padding-left: 25px;
	padding-right: 25px;
}
.spinner {
	position: absolute;
	z-index: 999;
	top: 40%;
	left: 50%;
}
.spinnerBackground {
	background: rgba(255, 255, 255, 0.8);
	z-index: 998;
	position: absolute;
	height: 100%;
	width: 100%;
	margin: 0 auto;
	right: 0;
	bottom: 0;
}
.card {
	display: inline-block;
	margin-top: 5px;
	margin-bottom: 7px;
	margin-right: 10px;
}
.currentValueIcon {
	padding-right: 10px;
	padding-bottom: 10px;
}

#windchart {
	min-width: 350px;
	max-width: 400px;
	margin: 0 auto;
	display: inline-block;
}

.wrapper {
	display: inline-flex;
}
</style>



// WEBPACK FOOTER //
// Analytics.vue?c3888874